import { Component } from "react";
import { getPrintPreferences } from "../../actions/policy/policyActions";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

const mapStateToProps = (state) => {
  return {
    selectedPolicy: state.policyReducer && state.policyReducer.selectedPolicy
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getPrintPreferences: (selectedPolicy, history) =>
      dispatch(getPrintPreferences(selectedPolicy, history))
  };
};

class PrintPreferenceRequired extends Component {
  constructor(props) {
    super(props);
    this.state = { isLoading: this.props.isPrintPreferenceRequired };
  }

  componentDidMount() {
    if (this.props.isPrintPreferenceRequired && this.props.selectedPolicy) {
      this.props
        .getPrintPreferences(this.props.selectedPolicy, this.props.history)
        .then(() =>
          this.setState({
            isLoading: false
          })
        );
    }
  }

  render() {
    if (this.props.children && !this.state.isLoading) {
      return this.props.children;
    }
    return null;
  }
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(PrintPreferenceRequired)
);
